const NuestrasClases = () => {
    return (
        <section id="classes" className="bg-sand py-20 px-4 md:px-12">
            <div className="max-w-5xl mx-auto bg-terracotta p-1 sm:p-1.5 rounded-[4px_60px_4px_60px] shadow-lg">
                <div className="rounded-[4px_60px_4px_60px] overflow-hidden">
                    <video controls className="w-full h-90 object-cover">
                        <source src="/images/clases.mp4" type="video/mp4" />
                    </video>
                </div>
            </div>
        </section>
    );
};

export default NuestrasClases;
